import { FeedbackLevel, FeedbackVisibilityFragment } from "@/generated/graphql";

export enum FeedbackItemContent {
  Group = 0,
  Individual = 1,
  Peer = 2,
  Self = 3,
}

export const getVisibilityConstraints = (
  id: FeedbackItemContent,
  feedbackVisibility: FeedbackVisibilityFragment
) => {
  const showMarks =
    feedbackVisibility.feedbackViewLevel !== FeedbackLevel.Feedback;
  const showFeedbackCta =
    feedbackVisibility.feedbackViewLevel !== FeedbackLevel.Answer;
  const showGrades =
    id !== FeedbackItemContent.Peer ||
    (id === FeedbackItemContent.Peer && feedbackVisibility.showPeerScores);

  const disableAccess =
    id === FeedbackItemContent.Peer &&
    (feedbackVisibility.feedbackViewLevel === FeedbackLevel.Feedback ||
      (!feedbackVisibility.showPeerScores &&
        !feedbackVisibility.showPeerComments));

  const canDownLoadPdf = feedbackVisibility.withFeedbackPdf;

  return {
    showMarks,
    showFeedbackCta,
    showGrades,
    disableAccess,
    canDownLoadPdf,
  };
};
